import { styled } from "@mui/material/styles";
import { Title } from "@/shared/components";

export const ContactsTitle = styled(Title)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    fontSize: "1.875rem",
  },
}));
